export default __webpack_public_path__ + "static/media/art-0-main-md.d34889a3.jpg";